var React = require('react');

function PpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m45.883 38.0972v-29.63557c0-4.65398-3.8068-8.46163-8.4608-8.46163h-28.9623c-4.65398 0-8.4599 3.80765-8.4599 8.46163v29.63557c0 4.6531 3.80592 8.4608 8.4599 8.4608h2.597v-37.6334h14.4465c8.4383 0 13.5397 5.001 13.5397 12.2243v.1012c0 8.1839-6.3648 12.4268-14.2969 12.4268h-5.9105v12.8811h18.5865c4.654 0 8.4608-3.8077 8.4608-8.4608zm-26.9749-11.3071h6.1632c3.8916 0 6.164-2.3235 6.164-5.3541v-.1021c0-3.4848-2.4265-5.354-6.3137-5.354h-6.0135z","fill":"#d21115","fillRule":"evenodd"}));
}

PpInline.defaultProps = {"fill":"none","height":"47","viewBox":"0 0 46 47","width":"46"};

module.exports = PpInline;

PpInline.default = PpInline;
